import React, { useCallback } from 'react';

import { Link } from "react-router-dom";

import { FieldTable } from '../../components/FieldTable/FieldTable';
import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import {NonIdealState} from "../../components/NonIdealState";
import {Button, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {useGetShortcutsQueryQuery} from "../../generated/graphql";

const DashShortcutList = (props) => {
  const user = useContext(UserContext);
  const { loading, data, error } = useGetShortcutsQueryQuery();
  if (error) return <NonIdealState title="An error has occurred" />;
  const shortcuts = loading ? [] : data.me.campaignShortcuts;
  let content = null;
  if (loading || shortcuts.length) {
    const columns = [
      {
        header: 'Job Ref', accessor: 'job_reference', dataType: 'link',
        options: {
          getLink: ({field}) => ('/campaigns/' + field.value)
        }
      },
      {header: 'Name', accessor: 'name', dataType: 'default'},
      {header: 'Start Date', accessor: 'start_date', dataType: 'date'},
      {header: 'Status', accessor: 'status', dataType: 'default'},
      {
        header: '', accessor: 'id', width: 'buttons', dataType: 'default', noExport: true,
        options: {
          // eslint-disable-next-line react/display-name
          renderViewer: ({field}) => {
            return (field.raw ? '' : <Button size="small" color="warning" onClick={() => {
              user.removeFromShortcuts(field.value)
            }}><Delete/>Remove</Button>);
          }
        }
      }
    ];
    content = <FieldTable loading={loading} hasDelete={false} values={shortcuts} columns={columns} />;
  } else {
    content = <Typography variant="body1"><div>You have no shortcuts</div></Typography>;
  }
  return content;
};


export default DashShortcutList;
